module.exports = __webpack_public_path__ + "img/icon-menu-1.601504b4.svg";